import { useRef } from 'react'
import { useModalDialog } from '../../../hooks'
import { AddWebhookForm } from '../forms'

export const useWebhookDialog = () => {

  const { showModalDialog } = useModalDialog()
  const addRef = useRef()
  const editRef = useRef()

  const showAddWebhookDialog = (onSubmit, existingScopes = []) => {

    const config = {
      title: "Add Webhook",
      Content: AddWebhookForm,
      contentProps: {
        mode: "add",
        data: [],
        // Apps that already have a webhook row — hidden from the app dropdown so each
        // app can only be added once (an existing one is edited via the Edit dialog).
        existingScopes,
        submitForm: onSubmit,
        ref: addRef
      },
      onSubmit: () => addRef.current.dispatchEvent( new Event("submit", { cancelable: true, bubbles: true }) ),
      submitLabel: "Add",
      submitLabelLoading: "Saving..."
    }

    showModalDialog(config)
  }

  const showEditWebhookDialog = (data, onSubmit) => {

    const config = {
      title: "Edit Webhook",
      Content: AddWebhookForm,
      contentProps: {
        mode: "edit",
        data: data,
        submitForm: onSubmit,
        ref: editRef
      },
      onSubmit: () => editRef.current.dispatchEvent( new Event("submit", { cancelable: true, bubbles: true }) ),
      submitLabel: "Save",
      submitLabelLoading: "Saving..."
    }

    showModalDialog(config)
  }

  const showDeleteWebhookDialog = (data, onSubmit) => {
    const item = Array.isArray(data) ? data[0] : data

    const config = {
      title: "Delete Webhook",
      Content: () => <div>
              <div>Are you sure you want to delete the webhook for <b>{item?.app_display_name || item?.scope}</b>?</div>
            </div>,
      onSubmit: () => onSubmit(item),
      submitLabel: "Delete",
      submitLabelLoading: "Deleting..."
    }

    showModalDialog(config)
  }

  return {
    showAddWebhookDialog,
    showEditWebhookDialog,
    showDeleteWebhookDialog
  }
}
